<template>
  <div class="card-report">
    <v-card class="card mx-auto pa-4" outlined>
      <v-list-item three-line class="pa-0 fill-height">
        <v-list-item-content class="pa-0">
          <v-list-item-title v-html="data.title" class="card__title mb-1">
          </v-list-item-title>
          <v-card-text class="card__description pa-0 three-line-text">
            {{ data.description }}
          </v-card-text>
          <v-card-actions class="pl-0 flex-end pb-0">
            <v-btn
              class="card__btn rounded-0 pa-0"
              depressed
              color="primary"
              height="23"
              width="97"
              @click="onOpenReport"
            >
              View Reports
            </v-btn>
          </v-card-actions>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { SEGMENT_EVENTS } from '../../constants';

export default {
  props: ['data'],
  methods: {
    ...mapActions(['setCurrentFoundationalReport']),
    onOpenReport() {
      this.$router.push({
        name: 'Home | Foundational Report Modal',
        params: {
          id: this.data.id,
        },
      });
      this.setCurrentFoundationalReport(JSON.parse(JSON.stringify(this.data)));
      window.analytics.track(SEGMENT_EVENTS.OPENED_FOUNDATIONAL_REPORT_MODAL, {
        contentTitle: this.data.title,
        contentId: this.data.id,
        contentType: 'Foundational Reports',
      });
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  height: 100%;
}
.card {
  cursor: text;
  border: 0;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: 24px;
}
.card .card__title {
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.1px;
  color: #234025;
}
.card .card__description {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.1px;
  color: #7b7d7a;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  height: 51px;
  overflow: hidden;
  cursor: text;
}
.card .card__btn {
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  letter-spacing: 0.1px;
  text-transform: capitalize;
}
.three-line-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  white-space: normal;
}

@media (max-width: 1263px) {
  .card .card__btn {
    width: 100% !important;
  }
}
</style>
